import { Header } from "layouts/common/outside";
import { MprcLayoutOutside } from "layouts/common/outside/MprcLayoutOutside";
import { OutsideLayoutProvider } from "layouts/common/outside/OutsideLayoutProvider";
import { Sidebar } from "layouts/common/outside/Sidebar";
import { RequireAuth } from "layouts/RequireAuth";
import * as React from "react";
import { PropsWithChildren, useEffect, useState } from "react";
import { useLocation } from "react-router";

////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppProps {
    header?: React.ReactNode;
}

type Props = IAppProps & PropsWithChildren;

////////////////////////////////////////////////////////////////////////////////////////////////////////

export const BaseLayout: React.FC<Props> = ({ header, children }) => {

    const location = useLocation();
    const [currentPath, setCurrentPath] = useState("");
    //const [previousPath, setPreviousPath] = useState("");
    const mainPanel = React.useRef<HTMLElement | null>(null);

    useEffect(() => {
        if (location.pathname !== currentPath) {
            // setPreviousPath(currentPath);
            setCurrentPath(location.pathname);
            if (mainPanel && mainPanel.current) mainPanel.current.scrollTop = 0;
        }
    }, [location.pathname]);

    return (
        <RequireAuth>
            <OutsideLayoutProvider>
                <MprcLayoutOutside
                    headerComponent={header ?? <Header />}
                    sidebarComponent={<Sidebar />}
                >
                    {children}
                </MprcLayoutOutside>
            </OutsideLayoutProvider>
        </RequireAuth>
    );
};
